import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '@services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {

  const msalService = inject(MsalService);
  const router = inject(Router);
  const authService = inject(AuthService);

  const accounts = msalService.instance.getAllAccounts();

  if (accounts.length > 0) {
    // changed to non-observable as this isn't an async function
    if (authService.getUserByTokenSync() != undefined)
      return true;
  }

  router.navigate(['/login']);
  return false;
};
